import { Route } from 'vue-router'

export const isPrivate = (to: Route) => {
  return to.matched.some((record) => record.meta.private)
}
